export const defaultImage =
  process.env.VUE_APP_BASE_URL + 'img/default-placeholder.png'
